<div
	class="tooltipBox"
	[class.hidden]="!isVisible()"
>
	<span class="header">{{ title() }}</span>
	<span>
		<mat-icon
			color="accent"
			fontSet="fad"
			[fontIcon]="'fa-calendar-day'"
		/>
		{{ date().start | date: "EEE, MMM d, y" : "" : translate.getCurrentLang() }}
	</span>
	@if (isMoreThanDay()) {
		<span>
			<mat-icon
				color="accent"
				fontSet="fad"
				[fontIcon]="'fa-calendar-day'"
			/>
			{{ date().end | date: "EEE, MMM d, y" : "" : translate.getCurrentLang() }}
		</span>
	} @else {
		<span class="timeRange">
			@if (isAllDay()) {
				{{ T.SHARED_EVENT_CALENDER_TOOLTIP_ALL_DAY | translate }}
			} @else {
				{{ date().start | date: "h:mm a" : "" : translate.getCurrentLang() }}
				@if (hasEndDate() && difference() > 0) {
					<mat-icon
						class="dateRangeIcon"
						color="accent"
						fontSet="fad"
						[fontIcon]="'fa-arrow-right'"
					/>
					{{ date().end | date: "h:mm a" : "" : translate.getCurrentLang() }}
				}
			}
		</span>
	}
</div>
